





















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ParametersParameterFilterList from '@/components/parameters/parameter/filter-list.vue';
import ParametersParameterList from '@/components/parameters/parameter/list.vue';
import ParametersOverrideFilterList from '@/components/parameters/override/filter-list.vue';
import ParametersOverrideList from '@/components/parameters/override/list.vue';
import ParameterModel from '@/models/parameter-model';
import * as service from '@/services/parameters';
import { IParameter } from '@/interfaces/parameters';
import {
  RULE_FILTER_TYPE_EMEDE,
  RULE_FILTER_TYPE_OVERRIDE,
} from '@/settings/consts/rules-engine';

@Component({
  components: {
    PermissionAuth,
    ParametersParameterFilterList,
    ParametersParameterList,
    ParametersOverrideFilterList,
    ParametersOverrideList,
  },
})
export default class Parameters extends BaseComponent {
  public filter: any = {};
  public filterType: string = RULE_FILTER_TYPE_EMEDE;
  public filterTypes: any = {
    emede: RULE_FILTER_TYPE_EMEDE,
    override: RULE_FILTER_TYPE_OVERRIDE,
  };

  public filterTypesList: any[] = [
    {
      id: RULE_FILTER_TYPE_EMEDE,
      label: 'Regras',
    },
    {
      id: RULE_FILTER_TYPE_OVERRIDE,
      label: 'Hierarquias',
    },
  ];

  public onFilter(filter: any): void {
    this.filter = filter;
  }
}
